const Wallet = ({ ...props }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      stroke="currentColor"
      {...props}
    >
      <path
        d="M21.8267 18.3061V23.2928H1V7.74609H21.8267V12.7328"
        stroke="currentColor"
        strokeWidth="0.762667"
      />
      <path
        d="M23.0002 18.3054V13.0254H15.3735V18.3054H23.0002Z"
        stroke="currentColor"
        strokeWidth="0.762667"
      />
      <path
        d="M9.21335 7.74667H20.0667L15.96 1L4.52002 7.74667H9.21335ZM9.21335 7.74667L17.1334 3.05333"
        stroke="currentColor"
        strokeWidth="0.762667"
      />
      <path
        d="M13.8948 7.72438L18.0896 5.22684"
        stroke="currentColor"
        strokeWidth="0.762667"
      />
      <rect
        x="16.8398"
        y="14.7852"
        width="1.76"
        height="1.76"
        fill="currentColor"
      />
    </svg>
  )
}

export default Wallet
